import { render } from "./SupplierDetailView.vue?vue&type=template&id=b0e5662a"
import script from "./SupplierDetailView.vue?vue&type=script&lang=js"
export * from "./SupplierDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__